document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('[data-variant-media-gallery]');
  if (!galleries.length) return;

  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[^a-z0-9 ]/g, '');
  }

  function isShared(value) {
    const v = normalize(value);
    return v === 'all' || v === 'common' || v === 'lifestyle';
  }

  function getItemGroup(item) {
    const dataGroup = item.getAttribute('data-variant-group');
    if (dataGroup) return dataGroup;

    const img = item.querySelector('img');
    return img && img.alt ? img.alt : '';
  }

  function getVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  function getVariantData(gallery) {
    const script = gallery.querySelector('[data-variant-media-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariant(gallery) {
    const variantId = getVariantId();
    const data = getVariantData(gallery);

    if (!variantId || !data || !data.variants || data.variants.length <= 1) {
      return null;
    }

    return data.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    });
  }

  function getSelectedGroup(variant) {
    if (!variant) return '';
    return variant.option1 || variant.option2 || variant.option3 || '';
  }

  function shouldShow(group, selectedGroup) {
    const g = normalize(group);
    const s = normalize(selectedGroup);

    return (
      g === s ||
      g.includes(s) ||
      s.includes(g) ||
      isShared(g)
    );
  }

  function setItemVisibility(item, visible) {
    if (visible) {
      item.style.display = '';
      item.removeAttribute('hidden');
      item.setAttribute('aria-hidden', 'false');
    } else {
      item.style.display = 'none';
      item.setAttribute('hidden', 'hidden');
      item.setAttribute('aria-hidden', 'true');
    }
  }

  function filterGallery(gallery, selectedGroup) {
    const mainItems = gallery.querySelectorAll(
      '[data-variant-media-item], .product__media-item'
    );

    const thumbnailItems = gallery.querySelectorAll(
      '[data-variant-thumbnail-item], .thumbnail-list__item'
    );

    mainItems.forEach(function (item) {
      setItemVisibility(item, shouldShow(getItemGroup(item), selectedGroup));
    });

    thumbnailItems.forEach(function (item) {
      setItemVisibility(item, shouldShow(getItemGroup(item), selectedGroup));
    });
  }

  function activateFirstImage(gallery, selectedGroup) {
    const selected = normalize(selectedGroup);

    const visibleSlides = Array.from(
      gallery.querySelectorAll('[data-variant-media-item]:not([hidden]), .product__media-item:not([hidden])')
    );

    const firstVariantSlide =
      visibleSlides.find(function (slide) {
        return normalize(getItemGroup(slide)) === selected;
      }) || visibleSlides[0];

    if (!firstVariantSlide) return;

    const mediaId = firstVariantSlide.getAttribute('data-media-id');

    gallery.querySelectorAll('[data-variant-media-item], .product__media-item').forEach(function (slide) {
      slide.classList.remove('is-active');
    });

    firstVariantSlide.classList.add('is-active');

    if (mediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    }

    if (mediaId) {
      const thumbButton = gallery.querySelector('[data-target="' + mediaId + '"] button');

      if (thumbButton) {
        gallery.querySelectorAll('.thumbnail-list__item button').forEach(function (btn) {
          btn.removeAttribute('aria-current');
        });

        thumbButton.setAttribute('aria-current', 'true');
      }
    }
  }

  function updateTitle(variant) {
    const titleEl = document.querySelector('.product__title h1');
    if (!titleEl || !variant) return;

    const baseTitle =
      titleEl.dataset.baseTitle ||
      titleEl.textContent.split(' - ')[0];

    titleEl.dataset.baseTitle = baseTitle;
    titleEl.textContent = baseTitle + ' - ' + variant.title;
  }

  function updateGallery(forceFirstImage) {
    galleries.forEach(function (gallery) {
      const variant = getSelectedVariant(gallery);
      const selectedGroup = getSelectedGroup(variant);

      if (!variant || !selectedGroup) return;

      filterGallery(gallery, selectedGroup);

      if (forceFirstImage) {
        activateFirstImage(gallery, selectedGroup);
      }

      updateTitle(variant);
    });
  }

  function preloadImages() {
    galleries.forEach(function (gallery) {
      gallery.querySelectorAll('img').forEach(function (img) {
        if (img.src) {
          const preload = new Image();
          preload.src = img.src;
        }
      });
    });
  }

  document.addEventListener('change', function () {
    setTimeout(function () {
      updateGallery(true);
    }, 150);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.thumbnail') ||
      event.target.closest('.thumbnail-list__item')
    ) {
      return;
    }

    setTimeout(function () {
      updateGallery(true);
    }, 150);
  });

  setTimeout(function () {
    updateGallery(true);
  }, 400);

  setTimeout(preloadImages, 800);
});